import { CircularProgress } from '@mui/material';
import React from 'react';
import './spinner.css';

function Spinner() {
  return (
    <div className="loading" data-testid="loading_spinner">
      <div className="spinner-container">
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={{
            color: 'primary.spinner',
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
          }}
          size={40}
          thickness={4}
        />
      </div>
    </div>
  );
}
export default Spinner;
